import { PAGE_KINDS } from "../shared/constants/pageAgentIds";
import { FRONTEND_TOOL_CODES, FRONTEND_TOOL_NAMES } from "./frontendToolNames";
import { enumStringNode, isRefusal, refuse, requiredString, type FrontendTool } from "./frontendTool";

const ARG_FILTER_ID = "filterId";
const ARG_VALUE = "value";

/**
 * Sets one of the work queue's filters, or switches its tab. Declared on the work queue alone,
 * with the ids and values the screen registered; the executor re-checks both against the screen
 * as it is at the call, so a stale declaration cannot reach a filter the queue no longer offers.
 */
export const setFilterTool: FrontendTool = {
  name: FRONTEND_TOOL_NAMES.setFilter,
  declaration: (location, _caseReview, workQueue) => location?.page !== PAGE_KINDS.workQueue || workQueue === null ? null : {
    name: FRONTEND_TOOL_NAMES.setFilter,
    description: "Set one filter of the work queue, or switch its tab, to one of the values it offers.",
    parameters: {
      type: "object",
      properties: {
        [ARG_FILTER_ID]: enumStringNode(workQueue.filters.map((filter) => filter.id)),
        [ARG_VALUE]: enumStringNode([...new Set(workQueue.filters.flatMap((filter) => filter.values))]),
      },
      required: [ARG_FILTER_ID, ARG_VALUE],
    },
  },
  execute: (args, env) => {
    const filterId = requiredString(args, ARG_FILTER_ID);
    if (isRefusal(filterId)) return filterId;
    const value = requiredString(args, ARG_VALUE);
    if (isRefusal(value)) return value;
    if (env.workQueue === null) return refuse(FRONTEND_TOOL_CODES.outOfScope, "The work queue is not on this screen.");
    const filter = env.workQueue.filters.find((candidate) => candidate.id === filterId);
    if (filter === undefined) return refuse(FRONTEND_TOOL_CODES.outOfScope, `${filterId} is not a filter of the work queue.`);
    if (!filter.values.includes(value)) return refuse(FRONTEND_TOOL_CODES.invalidValue, `${value} is not a value ${filterId} offers.`);
    env.workQueue.setFilter(filterId, value);
    return { ok: true, filterId, value };
  },
};
